export function stripDownloadExtension(filename: string): string {
  return filename.replace(/\.[^/.]+$/, '');
}

export function csvDownloadFilename(
  filename: string,
  now: Date = new Date(),
): string {
  const timestamp = now.toISOString().split('T')[0];
  return `${stripDownloadExtension(filename)}-${timestamp}.csv`;
}

export function xlsxFilenameFromCsvFilename(csvFilename: string): string {
  if (csvFilename.toLowerCase().endsWith('.csv')) {
    return `${csvFilename.slice(0, -4)}.xlsx`;
  }
  return `${stripDownloadExtension(csvFilename)}.xlsx`;
}

export function xlsxDownloadFilename(
  filename: string,
  now: Date = new Date(),
): string {
  return xlsxFilenameFromCsvFilename(csvDownloadFilename(filename, now));
}
